import { ErrorBoundary } from '@/components/common'
import { CookieConsentBanner } from '@/components/common/CookieConsentBanner'
import { Providers } from './providers'
import { AppRouter } from './router'

export function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <AppRouter />
        <CookieConsentBanner />
      </Providers>
    </ErrorBoundary>
  )
}
